(function ($) {
  window.vt = window.vt || {}
  window.vt.initMain = (function () {
    function initialize() {
      const $body = $('body')
      $body.addClass('loaded')

      $('.focuspoint').focusPoint()

      // smooth scroll to the anchor id on link click
      document.querySelectorAll('a[href*="#"]:not([href="#"])').forEach((anchor) => {
        if (anchor.classList.contains('no-scrolling')) return
        anchor.addEventListener('click', (e) => {
          if (
            window.location.pathname.replace(/^\//, '') === anchor.pathname.replace(/^\//, '')
            && window.location.hostname === anchor.hostname
          ) {
            e.preventDefault()
            const element = document.querySelector(anchor.hash)
            if (!element) return
            const top = element.getBoundingClientRect().top + window.scrollY
            window.scrollTo({
              top,
              left: 0,
              behavior: 'smooth'
            })
          }
        })
      })

      // ripple link effect
      const rippleLink = (e, $target) => {
        let ink = $target.find('.ink')
        if (ink.length === 0) {
          $target.prepend("<span class='ink'></span>")
          ink = $target.find('.ink')
        }
        ink.removeClass('animate')

        if (!ink.height() && !ink.width()) {
          const d = Math.max($target.outerWidth(), $target.outerHeight())
          ink.css({ height: d, width: d })
        }

        const x = e.pageX - $target.offset().left - ink.width() / 2
        const y = e.pageY - $target.offset().top - ink.height() / 2

        ink.css({ top: `${y}px`, left: `${x}px` }).addClass('animate')
      }

      $(
        '.ripple-link, .action-link, .sublevel .nav-item, .mobile-navigation-items li,'
        + 'a.action-button, .right-section .nav-item > a, .right-section .nav-item label,'
        + '.social-link, .service-nav > .nav-item > a, .product-list-loadmore > a, .filter-list a, .add-to-cart-link, .search-tabs-item'
      ).on('click', function (e) {
        rippleLink(e, $(this))
      })

      // disable right click on images
      $body.on('contextmenu', 'img', () => false)
    }

    return {
      initialize
    }
  }())
}(jQuery))
